function t(t,n,o){const e={};for(const c in t){const r=t[c];let s="",f=!0;for(let t=0;t<r.length;t+=1){const e=r[t];e&&(s+=(!0===f?"":" ")+n(e),f=!1,o&&o[e]&&(s+=" "+o[e]))}e[c]=s}return e}export{t as default};
//# sourceMappingURL=composeClasses.js.map
